import actions from 'modules/booking/form/bookingFormActions';
import formReducers from 'modules/shared/form/formReducers';

export default formReducers(actions);
